/**
 * Countdown ticker
 * ---------------------------------------------------------------------------------------------------------------------
 * Drives every [data-countdown] rendered by snippets/countdown.liquid (Theme settings → Countdown). Loaded from
 * layout/theme.liquid only while the countdown is enabled.
 *
 * Once a second, for each countdown on the page:
 *   - before data-countdown-start: hidden
 *   - between start and data-countdown-end: shown, days/hours/minutes/seconds updated
 *   - from the end on: hidden for good
 *
 * The elements are looked up on every tick rather than once, so countdowns inserted later work without any wiring:
 * the configurator drawer (cloned from a <template> on open), the cart drawer (re-rendered on every cart change) and
 * the theme editor all add markup after this script ran.
 *
 * [data-countdown-colors="<end>"] (snippets/countdown-colors.liquid) is removed at its end time, which ends the
 * colour matching of sale badges and prices.
 *
 * [data-countdown-fallback] is content that a countdown REPLACES while it runs (the announcement bar in "replace"
 * mode). It is the next sibling of its countdown and is shown exactly when that countdown is not.
 *
 * Times are Unix seconds from the server; the visitor's own clock decides what is shown. It is what the visitor sees
 * everywhere else, and it keeps working on a page Shopify served from its cache.
 */
(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };

  const tick = () => {
    const now = Math.floor(Date.now() / 1000);

    document.querySelectorAll('[data-countdown]').forEach((countdown) => {
      const start = Number(countdown.dataset.countdownStart) || 0;
      const end = Number(countdown.dataset.countdownEnd) || 0;
      const running = now >= start && now < end;

      if (countdown.hidden === running) countdown.hidden = !running;

      const fallback = countdown.nextElementSibling;
      if (fallback?.hasAttribute('data-countdown-fallback') && fallback.hidden !== running) {
        fallback.hidden = running;
        // A marquee measured while hidden has no width; let it re-measure now that it is visible.
        if (!running) window.dispatchEvent(new Event('resize'));
      }

      if (!running) return;

      const remaining = end - now;
      const days = Math.floor(remaining / 86400);
      const daysElement = countdown.querySelector('[data-countdown-days]');

      setText(daysElement, daysElement?.hasAttribute('data-countdown-pad') ? pad(days) : String(days));
      setText(countdown.querySelector('[data-countdown-hours]'), pad(Math.floor((remaining % 86400) / 3600)));
      setText(countdown.querySelector('[data-countdown-minutes]'), pad(Math.floor((remaining % 3600) / 60)));
      setText(countdown.querySelector('[data-countdown-seconds]'), pad(remaining % 60));
    });

    // Colour matching ends with the countdown: sale badges and prices go back to the theme's sale colours.
    document.querySelectorAll('[data-countdown-colors]').forEach((element) => {
      if (now >= Number(element.dataset.countdownColors)) element.removeAttribute('data-countdown-colors');
    });
  };

  tick();
  setInterval(tick, 1000);
})();
